import { t } from "i18next";

import Button from "~/components/buttons/Button";
import Hint from "~/components/Hint";
import SidebarContent from "~/components/Sidebar/components/SidebarContent";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";
import SidebarHeaderHeadline from "~/components/Sidebar/components/SidebarHeaderHeadline";
import { normalizeTKey } from "~/types/typeHelpers.ts";

type Props = {
	onClose: () => void
};

const UpdateOrderBillingSettingsQuotaWarning = ({ onClose }: Props) => {
	return <div
		className="flex min-h-full w-full flex-col justify-start"
	>
		<SidebarHeader>
			<SidebarHeaderHeadline>Abrechnungsdetails bearbeiten</SidebarHeaderHeadline>
		</SidebarHeader>
		<SidebarContent>
			<Hint theme="info">
				Diese Bestellung ist einem Abrechnugskontingent zugeordnet und verfügt daher nicht über eigene
				Abrechnungseinstellungen.
			</Hint>
		</SidebarContent>
		<SidebarFooter>
			<Button theme="none"
					onClick={onClose}>
				{t(normalizeTKey("form:buttonTexts.cancel"))}
			</Button>
		</SidebarFooter>
	</div>;
};

export default UpdateOrderBillingSettingsQuotaWarning;